import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "col-12 p-col-12 p-md-12" }
const _hoisted_3 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_5 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_6 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_7 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_8 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_9 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_10 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_11 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_12 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_13 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_14 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_15 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_16 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_17 = { class: "col-12 p-col-12 p-md-12" }
const _hoisted_18 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_19 = { class: "col-12 p-col-12 p-md-12" }
const _hoisted_20 = { class: "card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Thống kê bệnh nhân" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Panel, { header: "Tình trạng bệnh nhân hiện tại" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", null, "Chọn thời gian tìm kiếm: ", -1)),
                  _createVNode(_component_Calendar, {
                    id: "date",
                    modelValue: _ctx.date,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
                    selectionMode: "range",
                    dateFormat: "dd/mm/yy",
                    showButtonBar: true,
                    showIcon: true,
                    manualInput: false,
                    monthNavigator: true,
                    yearNavigator: true,
                    yearRange: "2000:2100",
                    onDateSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectCalendar())),
                    onClearClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearCalendar()))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", null, "Tổng số bệnh nhân khám: ", -1)),
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: _ctx.dashboard.slKham,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dashboard.slKham) = $event)),
                    readonly: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", null, "Tổng số bn hiện có: ", -1)),
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: _ctx.dashboard.bN_Cu,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dashboard.bN_Cu) = $event)),
                    readonly: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", null, "Tổng số bệnh nhân mới: ", -1)),
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: _ctx.dashboard.bN_Moi,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dashboard.bN_Moi) = $event)),
                    readonly: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", null, "Tổng số bệnh nhân ra viện: ", -1)),
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: _ctx.dashboard.bN_RaVien,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dashboard.bN_RaVien) = $event)),
                    readonly: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", null, "Tổng số bệnh nhân chuyển viện: ", -1)),
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: _ctx.dashboard.bN_ChuyenVien,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dashboard.bN_ChuyenVien) = $event)),
                    readonly: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", null, "Tổng số bệnh nhân siêu âm: ", -1)),
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: _ctx.dashboard.sieuAm,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dashboard.sieuAm) = $event)),
                    readonly: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", null, "Tổng số bệnh nhân xquang: ", -1)),
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: _ctx.dashboard.xquang,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dashboard.xquang) = $event)),
                    readonly: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", null, "Tổng số bệnh nhân xét nghiệm: ", -1)),
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: _ctx.dashboard.xetNghiem,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dashboard.xetNghiem) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[24] || (_cache[24] = _createElementVNode("label", null, "Viện phí nội trú: ", -1)),
                  _createVNode(_component_InputNumber, {
                    id: "vienPhi_NoiTru",
                    modelValue: _ctx.dashboard.vienPhi_NoiTru,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dashboard.vienPhi_NoiTru) = $event)),
                    mode: "decimal",
                    minFractionDigits: 2,
                    maxFractionDigits: 5,
                    readonly: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[25] || (_cache[25] = _createElementVNode("label", null, "Viện phí ngoại trú: ", -1)),
                  _createVNode(_component_InputNumber, {
                    id: "vienPhi_NgoaiTru",
                    modelValue: _ctx.dashboard.vienPhi_NgoaiTru,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dashboard.vienPhi_NgoaiTru) = $event)),
                    mode: "decimal",
                    minFractionDigits: 2,
                    maxFractionDigits: 5,
                    readonly: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[26] || (_cache[26] = _createElementVNode("label", null, "Doanh thu nhà thuốc: ", -1)),
                  _createVNode(_component_InputNumber, {
                    id: "doanhthu_nhathuoc",
                    modelValue: _ctx.dashboard.doanhthu_nhathuoc,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.dashboard.doanhthu_nhathuoc) = $event)),
                    mode: "decimal",
                    minFractionDigits: 2,
                    maxFractionDigits: 5,
                    readonly: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", null, "Khám sức khoẻ: ", -1)),
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: _ctx.dashboard.khamSucKhoe,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.dashboard.khamSucKhoe) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_Panel, { header: "" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[28] || (_cache[28] = _createElementVNode("label", { style: {"font-weight":"bold","font-size":"16px"} }, "Biểu đồ thống kê bệnh nhân", -1)),
                    _createVNode(_component_apexchart, {
                      type: "bar",
                      options: _ctx.options,
                      series: _ctx.series
                    }, null, 8, ["options", "series"])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}